import axios from "./axios";

const OrderService = {
  getOrders: async (order_status, order_type, page = 1, text = "", from, to) => {
    let url = `/orders?page=${page}&page_limit=10&search=${text}&start=${from}&end=${to}&`;
    if (order_status) {
      url = url + `order_status=${order_status}&`;
    }
    if (order_type) {
      url = url + `order_type=${order_type}`;
    }
    try {
      const response = await axios.get(url);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getCateringRequest: async (type) => {
    try {
      const response = await axios.get(
        type === "All"
          ? "/catering-requests"
          : `/catering-requests?status=${type}`
      );
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  SingleCateringRequest: async (id) => {
    try {
      const response = await axios.get(`/catering-requests/${id}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  cateringRequestReject: async (id) => {
    try {
      const response = await axios.get(`/catering-requests/${id}/REJECT`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  cateringRequestApprove: async (id, type) => {
    try {
      const response = await axios.put(`/catering-requests/${id}/${type}`);
      return response.data.data;
    } catch (e) {
      return e?.response?.data
    }
  },
  getOrder: async (id) => {
    try {
      const response = await axios.get(`/orders/${id}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getCateringDetails: async (id) => {
    try {
      const response = await axios.get(`/catering-requests/${id}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getCateringDetailsEncripted: async (id) => {
    try {
      const response = await axios.get(`/catering-requests/code/${id}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getCaterings: async () => {
    try {
      const response = await axios.get("/catering-requests");
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  addCaterings: async (payload) => {
    try {
      const response = await axios.post("/catering-requests", payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateCatering: async (payload, id) => {
    try {
      const response = await axios.put(`/catering-requests/${id}`, payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  approveCaterings: async (id) => {
    try {
      const response = await axios.get(`/catering-requests/${id}/approve`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  changeOrderStatus: async (payload) => {
    try {
      const response = await axios.post("/orders/status", payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  acceptOrder: async (payload) => {
    try {
      const response = await axios.post("/orders/accept", payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  approveRejectCateringOrder: async (id, action) => {
    try {
      const response = await axios.put(`/catering-requests/${id}/${action}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  sendCustomerInvoice: async (id, catItems) => {
    try {
      const response = await axios.put(
        `/catering-request/${id}/invoice`,
        catItems
      );
      return response.data;
    } catch (e) {
      console.error(e);
    }
  },
  sendCustomerReview: async (id, catItems) => {
    try {
      const response = await axios.put(
        `/catering-request/${id}/send-for-review`,
        {}
      );
      return response.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateCateringRequestStatus: async (id, status) => {
    try {
      const response = await axios.put(`/catering-requests/${id}/status`, {
        status,
      });
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateTime: async (payload) => {
    try {
      const response = await axios.post("/updateOrderItems", payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
};

export default OrderService;
